// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import styles from './valid_line.module.less';
import cn from 'classnames';


interface i_valid_line_props {
    product?: string;
    period?: string;
}

const periods = {
    'Shared Datacenter': '3 months',
    'Dedicated Datacenter': '1 month',
    'ISP': '3 months',
    'ISP Premium': '1 month',
    'Rotating Residential': '1 month',
    'Events Tickets Residential': '3 months',
    'Sneakers Residential': '3 months'
};

const title_for_line =(product, period?)=>{
    const text = period=='1 W' ?
        '1 week' : period=='1 M' ? '1 month' : periods[product];
    return `Package valid for ${text}`;
};

export const Valid_Line = (props: i_valid_line_props)=>{
    const product = props.product || periods[1];
    const valid_text = title_for_line(product, props.period);
    const short = product == 'ISP' || product == 'ISP Premium';
    return <div className={cn(styles.valid_line_container,
      short && styles.short)}>
      <div className={styles.line}></div>
        <span className={styles.text}>{valid_text}</span>
      <div className={styles.line}></div>
    </div>;
};
